"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.smartOutline = void 0;
var lib_1 = require("./lib");
var globalWindow = typeof window === "undefined" ? undefined : window;
function smartOutline(win) {
    var w = win || globalWindow;
    if (!w)
        return;
    var doc = w.document;
    lib_1.globalCss(w, "\n    body.pointer-interaction *,\n    body.pointer-interaction *::before,\n    body.pointer-interaction *::after {\n      outline: 0 !important\n    }\n  ");
    window.addEventListener("keydown", function (e) {
        var body = doc.querySelector("body");
        if (!body)
            return;
        if (e.key !== "Tab")
            return;
        body.classList.remove("pointer-interaction");
    });
    window.addEventListener("mousedown", function () {
        var body = doc.querySelector("body");
        if (!body)
            return;
        body.classList.add("pointer-interaction");
    });
}
exports.smartOutline = smartOutline;
//# sourceMappingURL=smartOutline.js.map